"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8435],{

/***/ 5618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AddToCartButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4337);
/* harmony import */ var hooks_cart_useAddToCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4688);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8356);
/* harmony import */ var _UI_Icons_Catalogue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5862);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5260);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






/**
 * AddToCartButton
 *
 * Button for product card that executes
 * a function to add product to cart
 *
 * @prop {object} product - the product data object
 */ function AddToCartButton(_param) {
    var product = _param.product, rest = _objectWithoutProperties(_param, [
        "product"
    ]);
    var addToCart = (0,hooks_cart_useAddToCart__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(product).addToCart;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        display: "flex",
        spaceX: "0.5rem",
        whiteSpace: "nowrap"
    }, rest, {
        onClick: addToCart,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                role: "img",
                "aria-label": "Shopping cart",
                children: _UI_Icons_Catalogue__WEBPACK_IMPORTED_MODULE_3__/* .AddToCart */ .o4
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xuv, {
                as: "span",
                fontSize: "14px",
                fontWeight: "400",
                color: "black",
                children: t("product_main.basket_add")
            })
        ]
    }));
};


/***/ }),

/***/ 5862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HZ": function() { return /* binding */ FilterBoxArrows; },
/* harmony export */   "LB": function() { return /* binding */ ZeroProducts; },
/* harmony export */   "o4": function() { return /* binding */ AddToCart; },
/* harmony export */   "wn": function() { return /* binding */ Filter; }
/* harmony export */ });
/* unused harmony export Compare */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var AddToCart = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.853",
    height: "15.557",
    viewBox: "0 0 16.853 15.557",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Group_180",
        "data-name": "Group 180",
        transform: "translate(-551.5 -815.5)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_114",
                "data-name": "Path 114",
                d: "M574.037,831.445h-1.3v-1.3a.648.648,0,1,0-1.3,0v1.3h-1.3a.648.648,0,0,0,0,1.3h1.3v1.3a.648.648,0,0,0,1.3,0v-1.3h1.3a.648.648,0,0,0,0-1.3Z",
                transform: "translate(-6.332 -4.925)",
                fill: "#1b1b1b"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_115",
                "data-name": "Path 115",
                d: "M563.524,829.761h-7.876a.649.649,0,0,1-.594-.381l-2.053-7.4h13.205l-.176.638a.648.648,0,0,0,1.25.345l.4-1.458a.649.649,0,0,0-.625-.821h-.889l-1.275-2.654a1.93,1.93,0,0,0-1.81-1.236h-.6a1.623,1.623,0,0,0-1.587-1.3h-2.593a1.623,1.623,0,0,0-1.587,1.3h-.6a1.908,1.908,0,0,0-1.79,1.191l-1.3,2.7h-.889a.648.648,0,0,0-.624.822l2.3,8.269a1.956,1.956,0,0,0,1.827,1.281h7.876a.648.648,0,0,0,0-1.3ZM558.306,816.8H560.9a.324.324,0,0,1,0,.648h-2.593a.324.324,0,0,1,0-.648ZM555.52,818.5a.641.641,0,0,1,.6-.41h.9a1.612,1.612,0,0,0,1.288.648H560.9a1.612,1.612,0,0,0,1.288-.648h.9a.666.666,0,0,1,.622.455l1.026,2.138H554.474Z",
                fill: "#1b1b1b"
            })
        ]
    })
});
var Compare = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.444",
    height: "15.743",
    viewBox: "0 0 12.444 15.743",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Group_1298",
        "data-name": "Group 1298",
        transform: "translate(-843.988 -1494.101)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_127",
                "data-name": "Path 127",
                d: "M8677.959,1501.245l-3.406,3.405,3.406,3.406",
                transform: "translate(-7829.814 -6.083)",
                fill: "none",
                stroke: "#9f9f9f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_128",
                "data-name": "Path 128",
                d: "M3.406,0,0,3.405,3.406,6.811",
                transform: "translate(855.682 1508.784) rotate(180)",
                fill: "none",
                stroke: "#9f9f9f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_129",
                "data-name": "Path 129",
                d: "M8666.568,1506.068h8.328",
                transform: "translate(-7821.83 -7.5)",
                fill: "none",
                stroke: "#9f9f9f",
                strokeLinecap: "round",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_130",
                "data-name": "Path 130",
                d: "M0,0H8.328",
                transform: "translate(855.682 1505.378) rotate(180)",
                fill: "none",
                stroke: "#9f9f9f",
                strokeLinecap: "round",
                strokeWidth: "1.5"
            })
        ]
    })
});
var FilterBoxArrows = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.698",
    height: "11.567",
    viewBox: "0 0 21.698 11.567",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Group_1301",
        "data-name": "Group 1301",
        transform: "translate(-15.293 -466.293)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Group_222",
                "data-name": "Group 222",
                transform: "translate(36.284 467) rotate(90)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    id: "Group_220",
                    "data-name": "Group 220",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            id: "Line_108",
                            "data-name": "Line 108",
                            x1: "3.973",
                            y1: "3.973",
                            transform: "translate(0 3.973)",
                            fill: "none",
                            stroke: "#52c1d3",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                            id: "Line_109",
                            "data-name": "Line 109",
                            x1: "3.973",
                            y2: "3.973",
                            fill: "none",
                            stroke: "#52c1d3",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "1"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Group_1300",
                "data-name": "Group 1300",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "Group_221",
                        "data-name": "Group 221",
                        transform: "translate(16 477.153) rotate(-90)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                id: "Group_220-2",
                                "data-name": "Group 220",
                                transform: "translate(0)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                        id: "Line_108-2",
                                        "data-name": "Line 108",
                                        x1: "3.973",
                                        y1: "3.973",
                                        transform: "translate(0 3.973)",
                                        fill: "none",
                                        stroke: "#52c1d3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                        id: "Line_109-2",
                                        "data-name": "Line 109",
                                        x1: "3.973",
                                        y2: "3.973",
                                        fill: "none",
                                        stroke: "#52c1d3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                id: "Line_110",
                                "data-name": "Line 110",
                                x1: "10.153",
                                transform: "translate(0 3.973)",
                                fill: "none",
                                stroke: "#52c1d3",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                        id: "Line_110-2",
                        "data-name": "Line 110",
                        x1: "10.153",
                        transform: "translate(32.311 467) rotate(90)",
                        fill: "none",
                        stroke: "#52c1d3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1"
                    })
                ]
            })
        ]
    })
});
var Filter = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11.671",
    height: "9",
    viewBox: "0 0 11.671 9",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Group_1303",
        "data-name": "Group 1303",
        transform: "translate(-303.247 -467.881)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_401",
                "data-name": "Path 401",
                d: "M619.418,1366.381H608.747",
                transform: "translate(-305 -898)",
                fill: "none",
                stroke: "#52c1d3",
                strokeLinecap: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_402",
                "data-name": "Path 402",
                d: "M615.062,1366.381h-6.315",
                transform: "translate(-305 -894)",
                fill: "none",
                stroke: "#52c1d3",
                strokeLinecap: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_403",
                "data-name": "Path 403",
                d: "M611.9,1366.381h-3.157",
                transform: "translate(-305 -890)",
                fill: "none",
                stroke: "#52c1d3",
                strokeLinecap: "round",
                strokeWidth: "1"
            })
        ]
    })
});
var ZeroProducts = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            transform: "translate(-803 -436)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "13",
                    cy: "13",
                    r: "13",
                    transform: "translate(803 436)",
                    fill: "#fefefe"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.32-5.52a.908.908,0,0,0,.92.88.908.908,0,0,0,.92-.88l.86-7.52a.829.829,0,0,0-.8-1.02H2.26a.829.829,0,0,0-.8,1.02ZM1.5-1.62v.04A1.683,1.683,0,0,0,3.24.12a1.683,1.683,0,0,0,1.74-1.7v-.04a1.683,1.683,0,0,0-1.74-1.7A1.683,1.683,0,0,0,1.5-1.62Z",
                    transform: "translate(813 456)",
                    fill: "#1b1b1b"
                })
            ]
        })
    });
};


/***/ }),

/***/ 4567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ps": function() { return /* binding */ ProductCardBox; },
/* harmony export */   "YD": function() { return /* binding */ ButtonsContainer; },
/* harmony export */   "jF": function() { return /* binding */ ProductPrice; },
/* harmony export */   "tc": function() { return /* binding */ ProductTitle; }
/* harmony export */ });
/* unused harmony exports CrossSellCardBox, CrossSellProductTitle, CrossSellProductPrice, DiscountPercentage */
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7248);
/* harmony import */ var _UI_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1040);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        &:hover {\n          border: 0.7px solid ",
        ";\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  max-width: 270px;\n  padding: 0 1.25rem;\n  margin-right: 0.5rem;\n  border: 0.7px solid #d8d9e5;\n  border-radius: 12px;\n  background-color: white;\n  font-weight: 500;\n\n  @media (min-width: desktop) {\n    padding: '1rem 1rem 2rem';\n\n    ",
        "\n  }\n\n  a {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-decoration: none !important;\n\n    span#discount_badge {\n      position: absolute;\n      left: 8;\n      top: 8;\n      padding: 4px 8px;\n      color: white;\n      background: #334a5e;\n      font-size: 13px;\n      font-weight: 400;\n      border-radius: 12px;\n      z-index: 2;\n    }\n\n    img {\n      transform: scale(",
        ") translateY(10%);\n      transition: transform 0.4s;\n    }\n\n    &:hover {\n      img {\n        transform: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 40px;\n  font-size: xxsmall;\n  text-align: center;\n  line-clamp: 2;\n  z-index: 2;\n  overflow: hidden;\n\n  @media (min-width: desktop) {\n    height: 44px;\n    max-width: ",
        ";\n\n    font-size: ",
        ";\n\n    margin-top: ",
        ";\n\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 0.625rem 0 0.5rem;\n  color: teal-300;\n  font-size: xxsmall;\n  text-align: center;\n\n  @media (min-width: desktop) {\n    font-size: ",
        ";\n  }\n\n  span {\n    position: relative;\n    margin-right: 0.5rem;\n    font-size: xxsmall;\n    color: blue-200;\n\n    @media (min-width: desktop) {\n      font-size: xsmall;\n    }\n\n    &:after {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  position: relative;\n  margin-top: 1.5rem;\n  bottom: 1rem;\n  white-space: nowrap;\n  opacity: 0;\n\n  @keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes slide-up {\n    0% {\n      bottom: 0.5rem;\n    }\n    100% {\n      bottom: 1rem;\n    }\n  }\n\n  ",
        ":hover & {\n    animation: fade-in 0.4s forwards ease-out, slide-up 0.4s forwards;\n  }\n\n  @media (max-width: desktop) {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 22px;\n\n  @media (min-width: desktop) {\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  @media (min-width: desktop) {\n    margin-top: -1rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  @media (min-width: desktop) {\n    font-size: xsmall;\n    margin-bottom: 0.5rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  position: absolute;\n  bottom: -1.4rem;\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 38px;\n  height: 38px;\n  color: white;\n  background-color: pink-100;\n  border-radius: 50%;\n  font-size: xxsmall;\n  font-weight: 700;\n  z-index: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


// Regular product card
var ProductCardBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].divBox */ .ZPm.divBox(_templateObject1(), function(param) {
    var zoomOff = param.zoomOff;
    return zoomOff && (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .ivY)(_templateObject(), _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__.th.color("teal-100"));
}, function(param) {
    var scale = param.scale;
    return scale || 0.8;
}, function(param) {
    var zoomOff = param.zoomOff, hoverScale = param.hoverScale;
    return !zoomOff && "scale(".concat(hoverScale || 0.9, ") translateY(10%)");
});
var ProductTitle = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .ZPm.p(_templateObject2(), function(param) {
    var scale = param.scale;
    return scale ? "180px" : "initial";
}, function(param) {
    var scale = param.scale;
    return !scale && _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__.th.fontSize("xsmall");
}, function(param) {
    var scale = param.scale;
    return scale ? 0 : "1rem";
}, function(param) {
    var scale = param.scale;
    return scale ? 0 : "0.75rem";
});
var ProductPrice = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].pBox */ .ZPm.pBox(_templateObject3(), _UI_utils__WEBPACK_IMPORTED_MODULE_0__/* .FlexCenter */ .Lb, function(param) {
    var scale = param.scale;
    return scale ? _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__.th.fontSize("xsmall") : _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__.th.fontSize("small");
}, _UI_utils__WEBPACK_IMPORTED_MODULE_0__/* .CrossOut */ .B4);
var ButtonsContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].divBox */ .ZPm.divBox(_templateObject4(), ProductCardBox);
// Cross-sell product card
var CrossSellCardBox = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZPm)(ProductCardBox)(_templateObject5());
var CrossSellProductTitle = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZPm)(ProductTitle)(_templateObject6());
var CrossSellProductPrice = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZPm)(ProductPrice)(_templateObject7());
var DiscountPercentage = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZPm.span(_templateObject8(), _UI_utils__WEBPACK_IMPORTED_MODULE_0__/* .FlexCenter */ .Lb);


/***/ }),

/***/ 9565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  z-index: 1;\n\n  span {\n    svg {\n      transform: ",
        ";\n    }\n\n    &:nth-child(2) {\n      font-size: xxsmall;\n      font-weight: 400;\n      color: #9c9c9c;\n      transform: translateY(5%);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RatingWrapper = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].divBox */ .ZPm.divBox(_templateObject(), function(param) {
    var scale = param.scale;
    return "scale(".concat(scale, ")") || 0;
});
function StarRating(_param) {
    var rating = _param.rating, scale = _param.scale, rest = _objectWithoutProperties(_param, [
        "rating",
        "scale"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RatingWrapper, _objectSpread({}, rest, {
        scale: scale,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                role: "img",
                "aria-label": "Star rating",
                children: Star
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    rating / 20,
                    "/5"
                ]
            })
        ]
    }));
};
var Star = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        id: "Polygon_25",
        "data-name": "Polygon 25",
        d: "M7.107,1.775a1,1,0,0,1,1.786,0l1.353,2.687A1,1,0,0,0,11,5l2.987.434a1,1,0,0,1,.551,1.709L12.393,9.21a1,1,0,0,0-.291.889l.5,2.924a1,1,0,0,1-1.444,1.058l-2.7-1.393a1,1,0,0,0-.917,0l-2.7,1.393A1,1,0,0,1,3.4,13.022L3.9,10.1a1,1,0,0,0-.291-.889L1.467,7.145a1,1,0,0,1,.551-1.709L5,5a1,1,0,0,0,.749-.54Z",
        fill: "#96e7e7"
    })
});


/***/ }),

/***/ 1368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ toastStyles; }
/* harmony export */ });
var toastStyles = function(param) {
    var isDesktop = param.isDesktop, padding = param.padding, background = param.background;
    return {
        background: background,
        padding: padding || "0.5rem",
        whiteSpace: isDesktop ? "nowrap" : "initial",
        maxWidth: isDesktop ? "max-content" : "initial",
        position: "relative",
        top: isDesktop ? "-30px" : 0
    };
};


/***/ }),

/***/ 4688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAddToCart; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./graphql/mutations/index.js + 30 modules
var mutations = __webpack_require__(9592);
;// CONCATENATED MODULE: ./lib/Google/events/addToCart.gtag.js
function addToCartEvent(product) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var price = product === null || product === void 0 ? void 0 : (ref = product.price_range) === null || ref === void 0 ? void 0 : ref.maximum_price;
    return gtag("event", "add_to_cart", {
        currency: "EUR",
        value: price === null || price === void 0 ? void 0 : (ref1 = price.final_price) === null || ref1 === void 0 ? void 0 : ref1.value,
        items: [
            {
                currency: "EUR",
                quantity: 1,
                item_name: product === null || product === void 0 ? void 0 : product.name,
                item_category: (product === null || product === void 0 ? void 0 : product.categories) ? (ref2 = product === null || product === void 0 ? void 0 : product.categories[0]) === null || ref2 === void 0 ? void 0 : ref2.name : "",
                item_category2: (product === null || product === void 0 ? void 0 : product.categories) ? (ref3 = product === null || product === void 0 ? void 0 : product.categories[1]) === null || ref3 === void 0 ? void 0 : ref3.name : "",
                item_category3: (product === null || product === void 0 ? void 0 : product.categories) ? (ref4 = product === null || product === void 0 ? void 0 : product.categories[2]) === null || ref4 === void 0 ? void 0 : ref4.name : "",
                item_brand: product === null || product === void 0 ? void 0 : (ref5 = product.mpbrand) === null || ref5 === void 0 ? void 0 : ref5.value,
                price: price === null || price === void 0 ? void 0 : (ref6 = price.final_price) === null || ref6 === void 0 ? void 0 : ref6.value,
                discount: price === null || price === void 0 ? void 0 : (ref7 = price.discount) === null || ref7 === void 0 ? void 0 : ref7.value
            }
        ]
    });
};

// EXTERNAL MODULE: ./hooks/cart/useCartId.js
var useCartId = __webpack_require__(3580);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./components/UI/Toast/toastStyles.js
var toastStyles = __webpack_require__(1368);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
;// CONCATENATED MODULE: ./components/UI/Toast/CartToast.js





function newItemInCartToast(param) {
    var name = param.name, onClick = param.onClick, isDesktop = param.isDesktop, text1 = param.text1, text2 = param.text2;
    return (0,react_hot_toast_esm/* default */.ZP)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
            as: "span",
            role: "button",
            "aria-label": "Go to product ".concat(name, " page"),
            align: "center",
            spaceX: "1rem",
            cursor: "pointer",
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                    as: "span",
                    role: "img",
                    "aria-label": "Product added to cart",
                    position: "relative",
                    top: 4,
                    children: Cart
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        text1,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                " ",
                                name,
                                " "
                            ]
                        }),
                        " ",
                        text2
                    ]
                })
            ]
        });
    }, {
        style: (0,toastStyles/* toastStyles */.j)({
            isDesktop: isDesktop,
            background: "#C8FDEB"
        })
    });
};
var Cart = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        id: "Group_1297",
        "data-name": "Group 1297",
        transform: "translate(-684 -371)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                id: "Ellipse_30",
                "data-name": "Ellipse 30",
                cx: "13",
                cy: "13",
                r: "13",
                transform: "translate(684 371)",
                fill: "#e6fff6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_180",
                "data-name": "Group 180",
                transform: "translate(137.397 -439.778)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_114",
                        "data-name": "Path 114",
                        d: "M574.037,831.445h-1.3v-1.3a.648.648,0,1,0-1.3,0v1.3h-1.3a.648.648,0,0,0,0,1.3h1.3v1.3a.648.648,0,0,0,1.3,0v-1.3h1.3a.648.648,0,0,0,0-1.3Z",
                        transform: "translate(-6.332 -4.925)",
                        fill: "#1b1b1b"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_115",
                        "data-name": "Path 115",
                        d: "M563.524,829.761h-7.876a.649.649,0,0,1-.594-.381l-2.053-7.4h13.205l-.176.638a.648.648,0,0,0,1.25.345l.4-1.458a.649.649,0,0,0-.625-.821h-.889l-1.275-2.654a1.93,1.93,0,0,0-1.81-1.236h-.6a1.623,1.623,0,0,0-1.587-1.3h-2.593a1.623,1.623,0,0,0-1.587,1.3h-.6a1.908,1.908,0,0,0-1.79,1.191l-1.3,2.7h-.889a.648.648,0,0,0-.624.822l2.3,8.269a1.956,1.956,0,0,0,1.827,1.281h7.876a.648.648,0,0,0,0-1.3ZM558.306,816.8H560.9a.324.324,0,0,1,0,.648h-2.593a.324.324,0,0,1,0-.648ZM555.52,818.5a.641.641,0,0,1,.6-.41h.9a1.612,1.612,0,0,0,1.288.648H560.9a1.612,1.612,0,0,0,1.288-.648h.9a.666.666,0,0,1,.622.455l1.026,2.138H554.474Z",
                        fill: "#1b1b1b"
                    })
                ]
            })
        ]
    })
});

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var dist_esm = __webpack_require__(5260);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./global/constants.js
var constants = __webpack_require__(827);
;// CONCATENATED MODULE: ./utils/cartErrorHandler.js


var clearCartId = function() {
    var cookies = new es6/* default */.Z();
    cookies.remove(constants/* CART_ID */.je, {
        path: "/"
    });
};
var isCartIdError = function(error) {
    var ref;
    return error === null || error === void 0 ? void 0 : (ref = error.message) === null || ref === void 0 ? void 0 : ref.includes("Could not find a cart with ID");
};

;// CONCATENATED MODULE: ./hooks/cart/useAddToCart.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















function useAddToCart(product) {
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var isDesktop = viewportWidth >= 1024;
    var cartId = (0,useCartId/* default */.Z)(); // Keep your original hook!
    var ref9 = _slicedToArray((0,useMutation/* useMutation */.D)(mutations/* ADD_SIMPLE_PRODUCT_TO_CART */.ch), 2), addSimpleProductToCart = ref9[0], ref1 = ref9[1], simpleProductLoading = ref1.loading;
    var ref2 = _slicedToArray((0,useMutation/* useMutation */.D)(mutations/* ADD_CONF_PRODUCT_TO_CART */.Ac), 2), addConfProductToCart = ref2[0], ref3 = ref2[1], confProductLoading = ref3.loading;
    var ref4 = _slicedToArray((0,esm/* useAtom */.KO)(store/* productVariantsAtom */.CA), 2), variants = ref4[0], setVariants = ref4[1];
    var ref5 = _slicedToArray((0,esm/* useAtom */.KO)(store/* addToCartErrorAtom */.z8), 2), error = ref5[0], setError = ref5[1];
    var setCartOpen = (0,esm/* useSetAtom */.b9)(store/* cartSidebarAtom */.zj);
    var simpleProduct = (product === null || product === void 0 ? void 0 : product.__typename) === "SimpleProduct";
    var sku = product === null || product === void 0 ? void 0 : product.sku;
    (0,react.useEffect)(function() {
        if (error) {
            var timer = setTimeout(function() {
                return setError(false);
            }, 3000);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        error
    ]);
    var showSuccessToast = function() {
        newItemInCartToast({
            name: product === null || product === void 0 ? void 0 : product.name,
            onClick: function() {
                return setCartOpen(true);
            },
            isDesktop: isDesktop,
            text1: t("ui.product"),
            text2: t("ui.added_to_cart")
        });
    };
    var showErrorToast = function() {
        react_hot_toast_esm/* default.error */.ZP.error(t("toast.toast_error"), {
            style: {
                position: "relative",
                top: isDesktop ? "-30px" : 0
            }
        });
    };
    var addProductToCart = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref6, ref7, ref8;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        addToCartEvent(product); //GTAG add to cart
                        if (true) {
                            ;
                            fbq("track", "AddToCart", {
                                content_type: "product",
                                content_ids: [
                                    product === null || product === void 0 ? void 0 : product.id
                                ],
                                content_name: product === null || product === void 0 ? void 0 : product.name,
                                content_category: (product === null || product === void 0 ? void 0 : product.categories) ? product === null || product === void 0 ? void 0 : product.categories[(product === null || product === void 0 ? void 0 : product.categories.length) - 1].name : "",
                                value: product === null || product === void 0 ? void 0 : (ref = product.price_range) === null || ref === void 0 ? void 0 : (ref6 = ref.maximum_price) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.final_price) === null || ref7 === void 0 ? void 0 : ref7.value,
                                contents: [
                                    {
                                        id: product === null || product === void 0 ? void 0 : product.id,
                                        quantity: 1
                                    }
                                ],
                                currency: "EUR"
                            });
                        }
                        _ctx.prev = 2;
                        if (!simpleProduct) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 6;
                        return addSimpleProductToCart({
                            variables: {
                                cartId: cartId,
                                sku: sku
                            }
                        });
                    case 6:
                        showSuccessToast();
                        _ctx.next = 18;
                        break;
                    case 9:
                        ;
                        if (!((product === null || product === void 0 ? void 0 : (ref8 = product.configurable_options) === null || ref8 === void 0 ? void 0 : ref8.length) === (variants === null || variants === void 0 ? void 0 : variants.length))) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.next = 13;
                        return addConfProductToCart({
                            variables: {
                                cartId: cartId,
                                sku: sku,
                                selectedOptions: variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
                                    return variant.uid;
                                })
                            }
                        });
                    case 13:
                        showSuccessToast();
                        setVariants([]);
                        _ctx.next = 18;
                        break;
                    case 17:
                        {
                            setError(true);
                            showErrorToast();
                        }
                    case 18:
                        _ctx.next = 24;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error("Add to cart error:", _ctx.t0);
                        if (isCartIdError(_ctx.t0)) {
                            // Clear the invalid cart ID and reload page
                            clearCartId();
                            react_hot_toast_esm/* default.error */.ZP.error(t("toast.cart_expired_reloading"), {
                                style: {
                                    position: "relative",
                                    top: isDesktop ? "-30px" : 0
                                }
                            });
                            // Reload page to get new cart
                            setTimeout(function() {
                                window.location.reload();
                            }, 1500);
                        } else {
                            showErrorToast();
                        }
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    20
                ]
            ]);
        }));
        return function addProductToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var addToCart = function() {
        if (router.route === "/toode/[toode]" || simpleProduct) {
            addProductToCart();
        } else {
            router.push("/toode/".concat(product === null || product === void 0 ? void 0 : product.url_key));
        }
    };
    return {
        addToCart: addToCart,
        loading: simpleProductLoading || confProductLoading
    };
};


/***/ }),

/***/ 9926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductCardPrice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var utils_getProductPrice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5689);


function useProductCardPrice(prices) {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), price = ref1[0], setPrice = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref = (0,utils_getProductPrice__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prices), priceValue = ref.priceValue, discount = ref.discount;
        setPrice({
            value: priceValue,
            discount: discount
        });
    }, [
        prices
    ]);
    return price;
};


/***/ })

}]);